let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("97Lcj")).then(() => parcelRequire('1hCRG'));